import { gql } from "@apollo/client";

export const GET_CLUBS_SIMPLE = gql`
  query Query($filter: JSON, $offset: Int, $limit: Int, $sort: [[String]]) {
    clubs(filter: $filter, offset: $offset, limit: $limit, sort: $sort) {
      items {
        id
        name
        department
        stats
      }
    }
  }
`;

export const formaClubName = (club) => {
  if (!club) return "-";
  return club.name;
};
